import Vue from "vue";
import Vuex from "vuex";
import metafields from "../store/metafields";
import product from "../store/product";
import cart from "../store/cart";
import mockStore from "../../../stories/mocks/vueStore";

const createStore = () => {
  if (process.env.STORYBOOK) {
    Vue.use(Vuex);
    return new Vuex.Store(mockStore);
  } else {
    Vue.use(Vuex);
    return new Vuex.Store({
      strict: process.env.NODE_ENV !== "production",
      modules: {
        metafields,
        product,
        cart,
      },
    });
  }
};

export const store = createStore();
